import { Path } from 'src/components/molecules/BreadcrumbsPipe'
import {
  PostCalculationDSLError,
  isPostCalculationDSLError,
} from 'src/domain/error'
import {
  CalculationItemState,
  selectCalculationItemById,
} from 'src/slices/calculationItems/calculationItemsSlice'
import errorMessage from 'src/slices/services/error_message'
import { injectIndex } from 'src/utils/array'

interface EditCalculationDSLPresenter {
  breadcrumbs(storeName?: string, tenantName?: string): Path[]
  convertErrorToMessage(
    error: PostCalculationDSLError,
    calculationItemsState: CalculationItemState
  ): string
  convertErrorType(e: unknown): PostCalculationDSLError
}

const Presenter: EditCalculationDSLPresenter = {
  breadcrumbs(storeName?: string, tenantName?: string): Path[] {
    const paths = []

    if (storeName && tenantName) {
      paths.push({ title: storeName }, { title: tenantName })
    }

    paths.push({ title: '利用開始設定' }, { title: 'ステップ 3' })

    return injectIndex(paths)
  },
  convertErrorToMessage(error, calculationItemsState) {
    if (error.code === 'network') {
      return error.message
    }
    const calculationNames = error.errors
      ?.map(
        (err) =>
          selectCalculationItemById(calculationItemsState, err.calculation_id)
            ?.name
      )
      .filter((name) => name)
    if (!calculationNames || !calculationNames.length) return ''
    return `${calculationNames.join(
      'と'
    )}でエラーが発生しています。算出ロジックを確認してください。`
  },
  convertErrorType(err: unknown): PostCalculationDSLError {
    if (!isPostCalculationDSLError(err)) {
      return {
        code: 'network',
        message: errorMessage('network'),
        showSnackbar: false,
      }
    }
    return {
      code: err.code,
      message: err.message,
      showSnackbar: err.showSnackbar,
      errors: err.errors,
    }
  },
}

export default Presenter
